<template>
  <div class="el-col-24">
    <h5 class="warp-title">评价统计</h5>
    <el-form :inline="true" :model="searchForm" size="small" class="search">
      <el-form-item>
        <el-input v-model="searchForm.counselorUserName" placeholder="请输入顾问昵称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-radio-group v-model="searchForm.specifiedTime" size="small" @change="specifiedTimeChange">
          <el-radio-button :label="1">近30天</el-radio-button>
          <el-radio-button :label="2">近7天</el-radio-button>
          <el-radio-button :label="3">今天</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="统计时间">
        <el-date-picker
          v-model="timeList"
          type="daterange"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期" @change="timeChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" :loading="isSearchLoading">查找</el-button>
        <el-button @click="export1" :loading="isExportLoading">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="evaluateTime" label="日期" width="220"></el-table-column>
      <el-table-column prop="counselorUserId" label="顾问账号" width="220"></el-table-column>
      <el-table-column prop="counselorUserName" label="顾问昵称" width="220"></el-table-column>
      <el-table-column prop="evaluateDetailDescribe" label="问题备注"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-link type="primary" @click="queryEvaluateDetail(scope.row.id)">查看详情</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align="right"
      class="mt20"
      background>
    </el-pagination>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%" :close-on-click-modal="false" class="dialog">
      <div class="top">
        <p v-if="detailData">用户ID：{{detailData.evaluateUseId}}</p>
        <p v-if="detailData">课程顾问：{{detailData.counselorUserName}}</p>
        <p v-if="detailData">购买套餐：{{detailData.buyMeal}}</p>
        <p v-if="detailData">评价时间：{{detailData.evaluateTime}}</p>
      </div>
      <div class="middle">
        <p class="tips">评价内容：</p>
        <div class="item" v-for="(item, index) in detailData.evaluateList" :key="index">
          <p>{{item.evaluateProblem}}</p>
          <el-radio-group v-model="item.evaluateAnswer">
            <el-radio label="是" disabled>是</el-radio>
            <el-radio label="否" disabled>否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="bottom">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="暂无评价描述"
          v-model="detailData.evaluateDetailDescribe" disabled autosize>
        </el-input>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {queryEvaluateStatisticsPage, queryEvaluateDetail, exportEvaluateStatistics} from '@/api/appraiseManage/index.js'
export default {
  name: 'ServiceStatistics',
  watch: {
    timeList (newVal) {
      if (newVal.length === 0) {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
    }
  },
  data () {
    return {
      isExportLoading: false,
      isSearchLoading: false,
      dialogVisible: false,
      searchForm: {
        counselorUserName: '',
        specifiedTime: 1,
        currentPage: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      },
      timeList: [],
      total: 0,
      tableData: [],
      detailData: {}
    }
  },
  created () {
  },
  methods: {
    export1 () {
      let data = {
        counselorUserName: this.searchForm.counselorUserName,
        specifiedTime: this.searchForm.specifiedTime,
        startTime: '',
        endTime: ''
      }
      if (this.timeList.length > 0) {
        data.startTime = this.timeList[0]
        data.endTime = this.timeList[1]
      }
      this.isExportLoading = true
      exportEvaluateStatistics(data).then(res => {
        this.isExportLoading = false
        if (res.data.resultCode === 0) {
          window.open(res.data.resultData.fileDownLoadUrl)
        }
      }).catch(() => {
        this.isExportLoading = false
      })
    },
    queryEvaluateDetail (id) {
      this.dialogVisible = true
      queryEvaluateDetail({id: id}).then(res => {
        if (res.data.resultCode === 0) {
          this.detailData = res.data.resultData
        }
      })
    },
    specifiedTimeChange () {
      this.timeList = []
    },
    handleSizeChange (size) {
      this.searchForm.currentPage = 1
      this.searchForm.pageSize = size
      this.getEvaluateStatisticsList()
    },
    handleCurrentChange (current) {
      this.searchForm.currentPage = current
      this.getEvaluateStatisticsList()
    },
    timeChange () {
      this.searchForm.specifiedTime = ''
    },
    getEvaluateStatisticsList () {
      if (this.timeList.length > 0) {
        this.searchForm.startTime = this.timeList[0]
        this.searchForm.endTime = this.timeList[1]
      }
      this.isSearchLoading = true
      queryEvaluateStatisticsPage(this.searchForm).then(res => {
        this.isSearchLoading = false
        if (res.data.resultCode === 0) {
          this.tableData = res.data.resultData
          this.total = res.data.totalCount
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    search () {
      this.currentPage = 1
      this.getEvaluateStatisticsList()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table .cell{
  text-align: center;
}
.right{
  float: right;
  margin-bottom: 10px;
}
.dialog .top{
  display: flex;
  background-color: #eee;
  flex-wrap: wrap;
  padding: 10px;
  margin-bottom: 5px;
}
.dialog .top p{
  box-sizing: border-box;
  width: 50%;
  padding-right: 5px;
  margin: 5px 0;
}
.dialog .middle {
  padding: 5px;
}
.dialog .middle .tips{
  margin-bottom: 5px;
  font-weight: 700;
}
.dialog .middle .item{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  // font-size: 16px;
  color: #333;
  p{
    width: 74%;
  }
}
/deep/.el-textarea.is-disabled .el-textarea__inner{
  color: #333;
}
/deep/.el-radio__input.is-disabled+span.el-radio__label{
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/AppraiseManage/ServiceStatistics.vue